var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x81\xB4",
    d: "M20.4102 39.5898C17.7279 39.5898 15.2018 39.0755 12.832 38.0469C10.4753 37.0312 8.39193 35.625 6.58203 33.8281C4.78516 32.0182 3.3724 29.9349 2.34375 27.5781C1.32812 25.2083 0.820312 22.6823 0.820312 20C0.820312 17.3177 1.32812 14.7982 2.34375 12.4414C3.3724 10.0716 4.78516 7.98828 6.58203 6.19141C8.37891 4.38151 10.4557 2.96875 12.8125 1.95312C15.1823 0.924479 17.7083 0.410156 20.3906 0.410156C23.0729 0.410156 25.599 0.924479 27.9688 1.95312C30.3385 2.96875 32.4219 4.38151 34.2188 6.19141C36.0156 7.98828 37.4284 10.0716 38.457 12.4414C39.4857 14.7982 40 17.3177 40 20C40 22.6823 39.4857 25.2083 38.457 27.5781C37.4284 29.9349 36.0156 32.0182 34.2188 33.8281C32.4219 35.625 30.3385 37.0312 27.9688 38.0469C25.612 39.0755 23.0924 39.5898 20.4102 39.5898ZM20.4102 37.0703C22.7669 37.0703 24.974 36.6276 27.0312 35.7422C29.1016 34.8568 30.918 33.6328 32.4805 32.0703C34.056 30.5078 35.2799 28.6979 36.1523 26.6406C37.0378 24.5703 37.4805 22.3568 37.4805 20C37.4805 17.6432 37.0378 15.4362 36.1523 13.3789C35.2669 11.3086 34.043 9.49219 32.4805 7.92969C30.918 6.35417 29.1016 5.13021 27.0312 4.25781C24.974 3.3724 22.7604 2.92969 20.3906 2.92969C18.0339 2.92969 15.8203 3.3724 13.75 4.25781C11.6927 5.13021 9.88281 6.35417 8.32031 7.92969C6.77083 9.49219 5.55339 11.3086 4.66797 13.3789C3.79557 15.4362 3.35938 17.6432 3.35938 20C3.35938 22.3568 3.79557 24.5703 4.66797 26.6406C5.55339 28.6979 6.77734 30.5078 8.33984 32.0703C9.90234 33.6328 11.7122 34.8568 13.7695 35.7422C15.8268 36.6276 18.0404 37.0703 20.4102 37.0703ZM16.0938 29.5703C15.8594 29.349 15.7422 29.0755 15.7422 28.75C15.7422 28.4245 15.8594 28.1576 16.0938 27.9492L24.4141 19.9805L16.0938 12.0117C15.8464 11.7904 15.7292 11.5169 15.7422 11.1914C15.7552 10.8659 15.8724 10.599 16.0938 10.3906C16.3151 10.1823 16.5755 10.0781 16.875 10.0781C17.1875 10.0781 17.4609 10.1953 17.6953 10.4297L26.1523 18.5156C26.4388 18.776 26.6276 19.0885 26.7188 19.4531C26.8229 19.8047 26.8229 20.1562 26.7188 20.5078C26.6276 20.8594 26.4388 21.1654 26.1523 21.4258L17.6953 29.5312C17.474 29.7396 17.2005 29.8503 16.875 29.8633C16.5625 29.8633 16.3021 29.7656 16.0938 29.5703Z",
    fill: "url(#paint0_linear_5970_17501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5970_17501",
    x1: 0.382913,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#FF474B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FF8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#FFA30A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlider);
export default __webpack_public_path__ + "static/media/arrow-slider.40933969ed66547ce8efb00ae1122152.svg";
export { ForwardRef as ReactComponent };